import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom'; //Redirect
// import { Container } from 'reactstrap';
import PropTypes from 'prop-types';

import {
	AppFooter,
	AppHeader,
} from '@coreui/react';
// sidebar nav config
// routes config
import routes from '../../routes';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import ParadigmaHeaderMenu from '../../components/ParadigmaHeaderMenu';

import Sidebar from '../../components/Sidebar';

import './styles.scss';

import CartProvider from "../../components/ParadigmaCartProvider";
import LoginProvider from "../../components/ParadigmaLoginProvider";

import api from "../../api";
import functions from "../../api/functions.js";

import { LoginContext } from "../../components/ParadigmaLoginProvider";

class DefaultLayout extends Component {
	constructor() {
		super();
		this.state = {
			menuBackdrop: false,
			Menues: [],
		}
	}

	static propTypes = {
		children: PropTypes.node,
		Configuracion: PropTypes.object,
	}

	componentDidMount() {
		this.loadMenues();
	}

	loadMenues() {
		functions.get(api.api.menu, null, null, null, (data) => {
			this.setState({ Menues: data.data.sort((a,b)=>a.Nombre > b.Nombre) });
		});
	}

	toggleMenuBackdrop(show) {
		this.setState((prevState) => {
			prevState.menuBackdrop = show;
			return prevState;
		});
	}

	render() {
		const { Configuracion } = this.props;
		const { menuBackdrop, Menues } = this.state;
		return (
			<LoginProvider>
				<CartProvider>
					<div className="app">
						<AppHeader className="esige-header pt-2">
							<div className="container">
								<DefaultHeader Configuracion={Configuracion} Menues={Menues} />
							</div>
						{
							Menues.length > 0 &&
							<div className="esige-menu">
								<div className={"container"}>
									<ParadigmaHeaderMenu
										Menues={Menues}
										onMenuWillOpen={() => this.toggleMenuBackdrop(true)}
										onMenuWillClose={() => this.toggleMenuBackdrop(false)}
									/>
								</div>
							</div>
						}

						</AppHeader>
						<div className="app-body">
							<main className="main">
								{/*<Container fluid>*/}
									<Switch>
										{routes.filter(x => !x.logged).map((route, idx) => {
											return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
												<route.component {...props} Menues={Menues} Configuracion={Configuracion} />
											)} />)
											: (null);
										})}
										<LoginContext.Consumer>
											{({ logged, logout }) => {
												if (logged) {
													return routes.filter(x => x.logged).map((route, idx) => {
														return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
															<route.component {...props} Configuracion={Configuracion} />
														)} />)
															: (null);
													});
												} else {
													return routes.filter(x => x.logged).map((route, idx) => {
														return <Redirect key={idx} path={route.path} to={"/"} exact={route.exact} />;
													});
												}
											}
											}
										</LoginContext.Consumer>

									</Switch>
								{/*</Container>*/}
							</main>
						</div>

						<DefaultFooter Configuracion={Configuracion} />

						{menuBackdrop && <div className="menu-backdrop"></div>}

					</div>
				</CartProvider>
			</LoginProvider>
		);
	}
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js